module.exports = __webpack_public_path__ + "img/campanha_carencia_zero.4fd1530f.png";